import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectReleasesRoute: InvariantJiraRoute = {
	name: 'legacy-project-releases',
	path: '/projects/:projectKey/versions/:id?',
};
